import { createProfessionalExporter } from '../../../utils/professionalExport';

const headers = ['Member', 'Branch', 'Date', 'Check In', 'Check Out', 'Duration', 'Status'];

function formatStatus(status) {
  return status === 'in-gym' ? 'In Gym' : 'Completed';
}

const exporter = createProfessionalExporter({
  title: 'Member Attendance',
  headers,
  slug: 'attendance',
  getRows: (list) =>
    list.map((r) => [
      r.member,
      r.branch,
      r.date,
      r.checkIn,
      r.checkOut || '—',
      r.duration,
      formatStatus(r.status),
    ]),
  getSummary: (list) => [
    `Total records: ${list.length}`,
    `Currently in gym: ${list.filter((r) => r.status === 'in-gym').length}`,
  ],
});

export const printAttendanceList = (data) => exporter.print(data);
export const exportAttendanceCsv = (data) => exporter.csv(data);
export const exportAttendanceExcel = (data) => exporter.excel(data);
export const exportAttendancePdf = (data) => exporter.pdf(data);
export const exportAttendance = (data) => exporter.export(data);
